import React from 'react';
import { FiltersPopover, MultiCombobox } from '@onward-delivery/design';

// Sits between the search box and the columns button. A shipper narrows by
// carrier, a carrier by shipper; `facet` is null for any other account type and
// the section does not render at all.
const FacetFilter = ({ facet, options, selectedIds, onChange, loading }) => {
    if (!facet) {
        return null;
    }

    return (
        <FiltersPopover
            activeCount={selectedIds.length}
            label="Filters"
            onClear={selectedIds.length ? () => onChange([]) : undefined}
            className="shrink-0"
        >
            <div className="flex min-w-56 flex-col gap-1">
                <span className="text-xs font-semibold tracking-wide text-muted">{facet.label.toUpperCase()}</span>
                <MultiCombobox
                    options={options}
                    value={selectedIds}
                    onValueChange={onChange}
                    // Loading rather than empty: an empty option list reads as
                    // "this client has no carriers", which is a different fact.
                    placeholder={loading ? 'Loading…' : `All ${facet.label.toLowerCase()}s`}
                    searchPlaceholder={`Search ${facet.label.toLowerCase()}s…`}
                    emptyText={`No ${facet.label.toLowerCase()}s found`}
                    disabled={loading && !options.length}
                />
            </div>
        </FiltersPopover>
    );
};

export default FacetFilter;
